import { Sparkles, Clock, Shield } from "lucide-react";

const HeroSection = () => {
  const scrollToQuiz = () => {
    document.getElementById('quiz')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-background via-secondary/20 to-background" />
      
      {/* Decorative elements */}
      <div className="absolute top-32 right-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-32 left-20 w-72 h-72 bg-accent/8 rounded-full blur-3xl animate-float" style={{ animationDelay: '-3s' }} />
      
      <div className="relative z-10 container mx-auto px-6 py-24 md:py-40">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <h1 className="inline-flex items-center gap-2.5 bg-card px-5 py-2.5 rounded-full border border-primary/15 mb-10 animate-fade-in text-base md:text-lg font-medium tracking-wide text-muted-foreground">
            <Sparkles className="w-5 h-5 md:w-6 md:h-6 text-primary flex-shrink-0" />
            Premium keratynowe prostowanie, nanoplastia włosów w Warszawie
          </h1>
          
          {/* Main headline */}
          <h2 className="heading-display text-foreground mb-8">
            Idealnie proste i posłuszne włosy przez{' '}
            <span className="text-[#ae7b12] drop-shadow-[0_1px_1px_rgba(0,0,0,0.3)] md:drop-shadow-none">5 miesięcy</span>: śpij 30 minut dłużej każdego dnia!
          </h2>
          
          {/* Subheadline */}
          <p className="text-body max-w-2xl mx-auto mb-12 animate-fade-in" style={{ animationDelay: '0.2s' }}>
            Zapomnij o prostownicy i puszeniu się włosów. Zabieg na preparatach premium z gwarancją rezultatu.
          </p>
          
          {/* CTA Button */}
          <div className="animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <button 
              onClick={scrollToQuiz}
              className="btn-primary text-base md:text-lg group relative overflow-hidden"
            >
              <span className="relative z-10">Oblicz koszt i odbierz prezent</span>
              <div className="absolute inset-0 bg-gradient-to-r from-primary via-gold-light to-primary bg-[length:200%_100%] animate-shimmer opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            </button>
          </div>
          
          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-10 mt-20 animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-card flex items-center justify-center border border-primary/15 shadow-soft">
                <Clock className="w-6 h-6 text-primary" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-foreground tracking-wide">Do 5 miesięcy</p>
                <p className="text-sm text-muted-foreground">efekt utrzymuje się</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-card flex items-center justify-center border border-primary/15 shadow-soft">
                <Shield className="w-6 h-6 text-primary" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-foreground tracking-wide">100% skutecznie</p>
                <p className="text-sm text-muted-foreground">preparaty premium</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-full bg-card flex items-center justify-center border border-primary/15 shadow-soft">
                <Sparkles className="w-6 h-6 text-primary" />
              </div>
              <div className="text-left">
                <p className="font-semibold text-foreground tracking-wide">Gwarancja</p>
                <p className="text-sm text-muted-foreground">rezultatu</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default HeroSection;
